import { render, staticRenderFns } from "./KernelStatusBadge.vue?vue&type=template&id=f1400816&"
import script from "./KernelStatusBadge.vue?vue&type=script&lang=js&"
export * from "./KernelStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports